<template>
  <ubi-page-container class="PostManager" wide-main-content>
    <el-row :gutter="24" class="PostManager-row">
      <el-col :xs="24" :lg="12" class="PostManager-col PostManager-col--main">
        <ubi-panel class="pb-4">
          <h1>{{ $t('socialMedia.title') }}</h1>
          <p>{{ $t('socialMedia.description') }}</p>

          <el-form ref="formPostAnnonce" :model="formPostAnnonce">
            <h3>{{ $t('socialMedia.titleTitle') }}</h3>
              <el-form-item>
                <el-input v-model="formPostAnnonce.titre" :disabled="true"></el-input>
                <span class="help">{{ $t('socialMedia.titleDescription') }}</span>
              </el-form-item>
              <h3>{{ $t('socialMedia.titleMedias') }}</h3>
              <el-row>
                <el-col :lg="24">
                  <el-form-item>
                    <el-radio-group v-model="currentMediaType" class="radio-group-media-type">
                      <el-radio label="image" :disabled="allRSPublished || getStatusMediaPost.hasVideoUrl || getStatusMediaPost.hasVideoUpload">{{ $t('socialMedia.mediaType.image') }}</el-radio>
                      <el-radio label="url" :disabled="allRSPublished || getStatusMediaPost.hasVideoUpload">{{ $t('socialMedia.mediaType.url') }}</el-radio>
<!--                      <el-radio label="upload" :disabled="getStatusMediaPost.hasVideoUrl">{{ $t('socialMedia.mediaType.upload') }}</el-radio>-->
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
          </el-form>
          <!-- Galerie Photos - toujours affichée -->
          <PhotoGallery
           v-if="currentMediaType === 'image'"
           :photos="adaptedPhotos"
           :title="$t('socialMedia.titlePhotoGallery')"
           :empty-message="$t('socialMedia.titleEmptyMessage')"
           @photos-changed="onPhotosChanged"
           @selection-changed="onSelectionChanged"
           @photo-selected="onPhotoSelected"
           @photos-reordered="onPhotosReordered"
           @all-selection-changed="onAllSelectionChanged" />

          <!-- Input URL - toujours affiché -->
          <el-form
            v-if="currentMediaType === 'url'"
            ref="formPostAnnonce"
            :model="formPostAnnonce"
          >
            <el-row :span="24" class="mt-3" >
              <h2 class="title">{{ $t('socialMedia.titleSelection') }}</h2>
              <el-form-item :error="inputError">
                <el-row>
                  <el-col :span="24">
                    <el-input v-model="localVideoUrl" @change="updateLinkToVideo" @input="validateUrlInput" type="url"
                      :placeholder="$t('socialMedia.titleInputUrl')" clearable></el-input>
                    <span class="help">{{ $t('socialMedia.titleHelp') }}</span>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-row>
          </el-form>

          <!-- Section Flow Vidéo - seulement si possedeClapVideo -->
          <ClapComponent
            v-if="currentMediaType === 'url'"
            :post="getCurrentPost"
            :universe="universe"
            :possede-clap-video="possedeClapVideo"
            @clap-ready="onClapReady"
            @clap-generation-started="onClapGenerationStarted"
            @clap-link-copied="onClapLinkCopied"
            @update-post="onUpdatePost"
          />

          <UploadVideo
              v-if="currentMediaType === 'upload'"
              :post-id="currentPostId"
              networkName="initial"
              @video-removed="onVideoRemoved"
              @upload-success="onVideoUploaded"
              @video-ready="onVideoReady"
          />
          <span v-if="localVideoUrl && localVideoUrl.trim() !== '' || getStatusMediaPost.hasVideoUpload" class="help" style="color: #f56c6c; display: block; margin-top: 5px;">
                 {{ $t('socialMedia.goBackPicturesOrUpload') }}
          </span>
        </ubi-panel>
      </el-col>
      <el-col :xs="24" :lg="12" class="PostManager-col PostManager-col--networks">
        <!-- Même enveloppe que les blocs RS éditoriaux (BlockEditoCreateSocialNetwork → ubi-panel) -->
        <template v-if="getCurrentPost">
          <ubi-panel
            v-for="network in networks"
            :key="network.id"
            class="PostManager-networkPanel"
          >
            <SocialMediaCard
              :icon-src="network.icon"
              :network-name="network.name"
              :active="network.active"
              :parent-video-url="formPostAnnonce.linkToVideo"
              :photos="adaptedPhotos"
              :selected-photos="selectedPhotos"
              :allRSPublished="allRSPublished"
              @video-url-changed="updateNetworkVideoUrl"
              @photo-selection-changed="onChildPhotoSelectionChanged"
              @update:active="updateNetworkActive(network.id, $event)"
            />
          </ubi-panel>
        </template>
      </el-col>
    </el-row>
    <hr />
    <div class="footer-actions-buttons mb-5">
      <el-dropdown class="mx-3" placement="top" @command="handleSaveCaption">
        <el-button type="primary" v-if="!allRSPublished" :disabled="(!hasPackSocialManager && !hasDiffusionsRs)" :loading="isSaving">
          {{ isSaving ? 'Enregistrement...' : $t('socialMedia.buttonSave') }}
        </el-button>
        <el-dropdown-menu>
          <el-dropdown-item command="saveAndContinue">{{ $t('socialMedia.buttonSaveChanges')}}</el-dropdown-item>
          <el-dropdown-item command="saveAndLeave">{{ $t('socialMedia.buttonSaveAndLeave')}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="success" @click="handleOpenScheduleModal" v-if="!allRSPublished" :disabled="publishButtonAvailable || (!hasPackSocialManager && !hasDiffusionsRs)">{{ $t('socialMedia.buttonPublish') }}</el-button>
      <router-link :to="{ name: 'social-posts' }" v-if="allRSPublished">
        <el-button>{{ $t('socialPosts.create.core.returnToList')}}</el-button>
      </router-link>
      <el-button @click="goToPreviousPage" v-else>{{ $t('socialMedia.buttonCancel') }}</el-button>
    </div>
    <ButtonScrollToTop @goToTop="goToTop" v-if="buttonIsVisible" />

    <!-- Modal de planification -->
    <PublishScheduleModal
      :visible="showScheduleModal"
      :networks="networks"
      :post="getCurrentPost || null"
      :universe="universe || ''"
      :is-bien-vendu="isBienVendu"
      :active-networks="activeNetworks"
      :get-caption-by-network="getCaptionByNetwork"
      @close="closeScheduleModal"
      @confirm-publish="handleConfirmPublish"
      @deactivate-networks="handleDeactivateNetworks"
    />

    <!-- Modale d'avertissement média -->
    <DialogMediaWarning
      :visible="showMediaWarning"
      @cancel="cancelMediaWarning"
      @confirm="confirmMediaWarning"
    />
  </ubi-page-container>
</template>
<script>
import UbiPageContainer from '@/components/PageContainer.vue'
import UbiPanel from '@/components/Panel.vue'
import { mapGetters } from 'vuex'
import PhotoGallery from '@/pages/posts/SocialMedia/components/PhotoGallery.vue'
import ClapComponent from '@/pages/posts/SocialMedia/components/ClapComponent.vue'
import { $t } from '@/i18n'
import SocialMediaCard from '@/pages/posts/SocialMedia/components/SocialMediaCard.vue'
import ButtonScrollToTop from '@/components/ui/ButtonScrollToTop.vue'
import { buttonScrollToTopMixin } from '@/mixins/buttonScrollToTopMixin'
import { getDiffuseur } from '@/helpers/functions/diffuseur'
import { transformDateTypeEnglishWithSpace } from '@/helpers/functions/convertDate'
import { generateCronExpression } from '@/services/socialNetworkTools'
import PublishScheduleModal from '@/pages/posts/SocialMedia/components/PublishScheduleModal.vue'
import DialogMediaWarning from '@/pages/posts/SocialMedia/components/DialogMediaWarning.vue'
import UploadVideo from '@/components/Upload/UploadVideo.vue'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import socialPostPublicationStatus from '@/mixins/socialPostPublicationStatus'
import { needsSocialNetworkSource } from '@/helpers/functions/socialCaptionFlux'

export default {
  name: 'PostManager',
  components: {
    UploadVideo,
    ClapComponent,
    ButtonScrollToTop,
    SocialMediaCard,
    PhotoGallery,
    UbiPanel,
    UbiPageContainer,
    PublishScheduleModal,
    DialogMediaWarning
  },
  mixins: [buttonScrollToTopMixin, socialPostPublicationStatus],
  data () {
    return {
      formPostAnnonce: {
        titre: '',
        linkToVideo: '',
        mediaType: ''
      },
      networks: [
        { id: 1, icon: require('@/assets/facebook-logo-5-1.png'), name: 'Facebook', active: false },
        { id: 2, icon: require('@/assets/2048px-Instagram_icon.png'), name: 'Instagram', active: false },
        { id: 3, icon: require('@/assets/google-logo-carre.png'), name: 'Google', active: false },
        { id: 4, icon: require('@/assets/linkedin-logo.png'), name: 'Linkedin', active: false }
      ],
      inputError: '',
      localVideoUrl: '', // Variable locale pour l'URL vidéo (comme dans PostEditoCreatePublicationInitiale)
      selectedPhotos: [],
      rawPhotos: [], // Photos dans votre format original
      photoSelections: new Map(), // Garder trace des sélections par ID
      networkVideoUrls: {},
      originalCaptions: new Map(), // Garder trace des captions originales pour détecter les changements
      isSaving: false, // Protection contre les appels multiples
      showScheduleModal: false,
      showMediaWarning: false,
      pendingAction: null, // Pour stocker l'action en attente après confirmation
      showModalDialogPublishNow: false,
      currentCommand: null,
      manualMediaTypeSelection: false, // Flag pour savoir si l'utilisateur a fait une sélection manuelle
    }
  },
  computed: {
    ...mapGetters('postManager', ['getCurrentPost', 'isBienVendu', 'universe', 'getSocialStatusPosts', 'getLoadingDiffusions', 'getVideoUrlsByNetwork', 'getStatusMediaPost', 'getMediaType', 'hasAnyMedia']),
    ...mapGetters('calendarSocialPosts', ['getListEventsByAnnonceByNetwork']),
    ...mapGetters(['getUser', 'getSitimmoUser', 'hasPackSocialManager', 'hasDiffusionsRs']),
    ...mapGetters('caption', ['getCaptionByNetwork']),
    // Computed property pour centraliser la récupération de l'ID du post
    currentPostId () {
      return this.$route.params.id || (this.getCurrentPost && this.getCurrentPost.id)
    },
    // Transformation de vos photos vers le format attendu par PhotoGallery
    adaptedPhotos () {
      return this.rawPhotos.map((photo, index) => {
        const id = photo.chaine_source || `photo-${index}`
        return {
          id: id, // Utilise chaine_source comme ID unique
          name: photo.nom_source || `Photo ${index + 1}`, // Utilise nom_source comme nom
          url: photo.url, // URL de l'image
          thumbnail: photo.url_miniature, // URL de la miniature
          selected: this.photoSelections.get(id) || false, // État de sélection depuis la Map
          originalData: photo // Garde une référence aux données originales
        }
      })
    },
    possedeClapVideo () {
      return this.getUser.possedeClap
    },
    isNeedSocialNetwork () {
      return needsSocialNetworkSource(this.getSitimmoUser)
    },
    activeNetworks () {
      return this.networks.filter(network => network.active)
    },
    // Vérifier s'il y a des planifications existantes (published ou scheduled)
    hasExistingPlanifications () {
      const socialStatusPosts = this.getSocialStatusPosts
      return Object.values(socialStatusPosts).some(post =>
        post.status === 'published' || post.status === 'scheduled'
      )
    },
    // Vérifier si on a à la fois des photos et une vidéo
    hasBothPhotosAndVideo () {
      const hasVideo = this.formPostAnnonce.linkToVideo && this.formPostAnnonce.linkToVideo.trim() !== ''
      const hasPhotos = this.adaptedPhotos && this.adaptedPhotos.length > 0
      return hasVideo && hasPhotos
    },
    publishButtonAvailable () {
      // Désactiver le bouton si aucun réseau n'est sélectionné
      return this.activeNetworks.length === 0
    },
    hasValidVideoUrl () {
      return this.urlIsValid(this.formPostAnnonce.linkToVideo) && this.formPostAnnonce.linkToVideo && this.formPostAnnonce.linkToVideo.trim() !== ''
    },
    hasUploadedVideo () {
      return this.getCurrentPost &&
          this.getCurrentPost.assets &&
          this.getCurrentPost.assets.VIDEO &&
          Object.values(this.getCurrentPost.assets.VIDEO).length > 0
    },

    // Utiliser le getter centralisé pour le type de média avec possibilité de sélection manuelle
    currentMediaType: {
      get () {
        // Si l'utilisateur a fait une sélection manuelle, la respecter
        if (this.manualMediaTypeSelection) {
          return this.formPostAnnonce.mediaType
        }
        // Sinon, utiliser le getter automatique
        return this.getMediaType
      },
      set (value) {
        // Permettre la sélection manuelle
        this.manualMediaTypeSelection = true
        this.formPostAnnonce.mediaType = value
      }
    },
    // Computed property réactive pour vérifier si tous les RS sont publiés
    allRSPublished () {
      const socialStatusPosts = this.getSocialStatusPosts
      if (!socialStatusPosts || Object.keys(socialStatusPosts).length === 0) {
        return false
      }

      // Vérifier si tous les réseaux disponibles ont un statut 'published'
      const availableNetworks = ['Facebook', 'Instagram', 'Google', 'Linkedin']
      return availableNetworks.every(network => {
        const status = socialStatusPosts[network]
        return status && status.status === 'published'
      })
    }
  },
  watch: {
    // Watcher pour synchroniser formPostAnnonce.linkToVideo avec localVideoUrl (comme dans PostEditoCreatePublicationInitiale)
    'formPostAnnonce.linkToVideo': {
      handler (newValue) {
        // Synchroniser la valeur locale avec formPostAnnonce
        if (newValue !== this.localVideoUrl) {
          this.localVideoUrl = newValue
        }
      },
      immediate: true
    },
    // Watcher sur l'ID du post pour détecter les changements de route
    currentPostId: {
      immediate: true,
      handler (newPostId, oldPostId) {
        // Si on change de post, réinitialiser les données locales
        if (oldPostId && newPostId !== oldPostId) {
          this.resetLocalData()
        }
      }
    },
    // Watcher qui se déclenche quand getCurrentPost change
    getCurrentPost: {
      immediate: true,
      handler (newPost) {
        if (newPost) {
          this.initializePostData(newPost)
        }
      }
    },
    getSocialStatusPosts: {
      handler (newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.activateNetworksWithExistingPlanifications()
        }
      },
      deep: true,
      immediate: true
    },
    // Watcher pour synchroniser les URLs vidéo quand elles changent dans le store
    getVideoUrlsByNetwork: {
      handler (newUrls, oldUrls) {
        if (newUrls && Object.keys(newUrls).length > 0) {
          // Mettre à jour l'URL initiale si elle existe
          if (newUrls.initial && newUrls.initial !== this.formPostAnnonce.linkToVideo) {
            this.formPostAnnonce.linkToVideo = newUrls.initial
          }

          // Mettre à jour les URLs par réseau
          this.networks.forEach(network => {
            const networkKey = network.name.toLowerCase()
            if (newUrls[networkKey] && newUrls[networkKey] !== this.networkVideoUrls[network.name]) {
              this.$set(this.networkVideoUrls, network.name, newUrls[networkKey])
            }
          })
        }
      },
      deep: true,
      immediate: true
    },
    // Watcher pour détecter les changements automatiques du type de média
    getMediaType: {
      handler (newType, oldType) {
        // Si pas de sélection manuelle et que le type automatique change, l'adopter
        if (!this.manualMediaTypeSelection && newType !== oldType) {
          this.formPostAnnonce.mediaType = newType
        }
      },
      immediate: true
    }
  },
  methods: {
    onMediaTypeChange (newType) {
      this.manualMediaTypeSelection = true
      this.formPostAnnonce.mediaType = newType
    },

    // Méthode utilitaire pour rafraîchir l'analyse des médias
    async refreshMediaAnalysis () {
      try {
        await this.$store.dispatch('postManager/refreshMediaAnalysis')
      } catch (error) {
      }
    },

    resetLocalData () {
      // Réinitialiser les données locales
      this.formPostAnnonce = {
        titre: '',
        linkToVideo: '',
        mediaType: ''
      }
      this.localVideoUrl = '' // Réinitialiser la variable locale
      this.selectedPhotos = []
      this.rawPhotos = []
      this.photoSelections = new Map()
      this.networkVideoUrls = {}
      this.originalCaptions = new Map()
      this.isSaving = false
      this.showScheduleModal = false
      this.showMediaWarning = false
      this.pendingAction = null
      this.showModalDialogPublishNow = false
      this.currentCommand = null
      this.manualMediaTypeSelection = false // Reset du flag de sélection manuelle
    },
    onPhotosChanged (photos) {
      // console.log('Photos modifiées:', photos)
      // Mettre à jour les sélections dans notre Map
      photos.forEach(photo => {
        this.photoSelections.set(photo.id, photo.selected)
      })
      // Propager le changement vers tous les enfants via les computed properties
    },
    onSelectionChanged (selectedPhotos) {
      // console.log('Sélection changée:', selectedPhotos)
      this.selectedPhotos = selectedPhotos

      // Mettre à jour notre Map des sélections
      selectedPhotos.forEach(photo => {
        this.photoSelections.set(photo.id, true)
      })
    },
    onPhotoSelected ({ photo, selected }) {
      // console.log(`Photo ${photo.name} ${selected ? 'sélectionnée' : 'désélectionnée'}`)
      // console.log('Données originales de la photo:', photo.originalData)
      // Mettre à jour la sélection dans notre Map
      this.photoSelections.set(photo.id, selected)

      // Mettre à jour la liste des photos sélectionnées
      if (selected) {
        if (!this.selectedPhotos.find(p => p.id === photo.id)) {
          this.selectedPhotos.push(photo)
        }
      } else {
        this.selectedPhotos = this.selectedPhotos.filter(p => p.id !== photo.id)
      }
    },
    onPhotosReordered ({ oldIndex, newIndex, photos }) {
      // console.log(`Photo déplacée de ${oldIndex} vers ${newIndex}`)
      // Mise à jour de l'ordre dans vos données originales
      this.rawPhotos = photos.map(adaptedPhoto => adaptedPhoto.originalData)
      // Mettre à jour les sélections après réorganisation
      photos.forEach(photo => {
        this.photoSelections.set(photo.id, photo.selected)
      })
    },
    onAllSelectionChanged (allSelected) {
      // console.log(`Toutes les photos ${allSelected ? 'sélectionnées' : 'désélectionnées'}`)
      // Mettre à jour toutes les sélections dans notre Map
      this.rawPhotos.forEach((photo, index) => {
        const id = photo.chaine_source || `photo-${index}`
        this.photoSelections.set(id, allSelected)
      })
      // Mettre à jour la liste des photos sélectionnées
      if (allSelected) {
        this.selectedPhotos = this.adaptedPhotos
      } else {
        this.selectedPhotos = []
      }
    },
    validateUrlInput (value) {
      // Validation en temps réel pendant la saisie (comme dans PostEditoCreatePublicationInitiale)
      this.inputError = ''
      if (value && !this.urlIsValid(value)) {
        this.inputError = this.$t('posts.networks.videoUrlError')
      }
    },
    updateLinkToVideo (value) {
      this.inputError = ''
      if (!value || this.urlIsValid(value)) {
        // Mettre à jour formPostAnnonce.linkToVideo pour la cohérence
        this.formPostAnnonce.linkToVideo = value

        // Mettre à jour seulement localement, pas de sauvegarde automatique
        this.$store.commit('postManager/updatePostVideoFileUrlCustom', {
          network: 'initial',
          url: value
        })

        // Si l'URL initiale est vidée (clearable ou supprimée), vider toutes les URLs des réseaux
        if (!value || value.trim() === '') {
          this.networks.forEach(network => {
            this.$set(this.networkVideoUrls, network.name, '')
            // Mettre à jour aussi dans le store pour chaque réseau
            this.$store.commit('postManager/updatePostVideoFileUrlCustom', {
              network: network.name.toLowerCase(),
              url: ''
            })
          })
        } else {
          // Propager l'URL initiale aux réseaux qui n'ont pas d'URL personnalisée
          this.networks.forEach(network => {
            const networkKey = network.name.toLowerCase()
            const videoUrls = this.getVideoUrlsByNetwork

            // Si le réseau n'a pas d'URL personnalisée, utiliser l'URL initiale
            if (!videoUrls[networkKey] || videoUrls[networkKey] === videoUrls.initial) {
              this.$set(this.networkVideoUrls, network.name, value)
            }
          })
        }

        // Déclencher l'analyse des médias pour mettre à jour getStatusMediaPost
        this.$nextTick(() => {
          this.$store.dispatch('postManager/analyzePostMedias', this.currentPostId)
        })
      } else {
        this.inputError = this.$t('posts.networks.videoUrlError')
        return false
      }
    },
    urlIsValid (urlString) {
      let isValid = false
      try {
        const urlVideo = new URL(urlString)
        isValid = (
          ((urlVideo.protocol === 'http:') || (urlVideo.protocol === 'https:')) &&
            (urlVideo.hostname.indexOf('youtube') === -1) &&
            (urlVideo.hostname.indexOf('dailymotion') === -1)
        )
      } catch (_) {
      }
      return isValid
    },
    // Nouvelle méthode pour mettre à jour le post
    onUpdatePost (updatedPost) {
      // Mettre à jour le post dans le store
      this.$store.commit('postManager/setCurrentPost', updatedPost)

      // Réinitialiser les données locales avec le post mis à jour
      this.initializePostData(updatedPost)
    },

    // Gestionnaires d'événements pour le composant Clap
    onClapReady (url) {
      // Mettre à jour l'input vidéo avec l'URL du clap
      if (url && (!this.formPostAnnonce.linkToVideo || this.formPostAnnonce.linkToVideo !== url)) {
        this.formPostAnnonce.linkToVideo = url
        this.updateLinkToVideo(url)
      }
    },

    onClapGenerationStarted () {
      // Rien de spécial à faire, juste pour information
    },

    onClapLinkCopied (url) {
      // Remplir automatiquement l'input vidéo avec le lien copié
      this.formPostAnnonce.linkToVideo = url

      // Valider l'URL
      if (this.urlIsValid(url)) {
        this.inputError = ''
        this.updateLinkToVideo(url)

        this.$message({
          type: 'success',
          message: 'URL du clap appliquée avec succès',
          duration: 2000
        })
      }
    },

    // Gestionnaire d'événement pour la suppression de vidéo uploadée
    onVideoRemoved (data) {
      // console.log('Vidéo supprimée, nettoyage de linkToVideo', data)

      // Vider le champ linkToVideo quand une vidéo uploadée est supprimée
      this.formPostAnnonce.linkToVideo = ''
      this.localVideoUrl = ''

      // Mettre à jour le store pour refléter le changement
      this.$store.commit('postManager/updatePostVideoFileUrlCustom', {
        network: 'initial',
        url: ''
      })

      // Vider toutes les URLs des réseaux également
      this.networks.forEach(network => {
        this.$set(this.networkVideoUrls, network.name, '')
        // Mettre à jour aussi dans le store pour chaque réseau
        this.$store.commit('postManager/updatePostVideoFileUrlCustom', {
          network: network.name.toLowerCase(),
          url: ''
        })
      })

      // Déclencher l'analyse des médias pour mettre à jour getStatusMediaPost
      this.$nextTick(() => {
        this.$store.dispatch('postManager/analyzePostMedias', this.currentPostId)
      })
    },

    // Gestionnaire d'événement pour l'upload réussi de vidéo
    onVideoUploaded (result) {
      // console.log('Vidéo uploadée avec succès', result)
      // L'analyse des médias est déjà déclenchée dans UploadVideo, mais on peut la redéclencher pour être sûr
      this.$nextTick(() => {
        this.$store.dispatch('postManager/analyzePostMedias', this.currentPostId)
      })
    },

    // Gestionnaire d'événement quand une vidéo est prête
    onVideoReady (video) {
      // console.log('Vidéo prête', video)
      // Déclencher l'analyse des médias pour mettre à jour getStatusMediaPost
      this.$nextTick(() => {
        this.$store.dispatch('postManager/analyzePostMedias', this.currentPostId)
      })
    },

    // Méthode pour initialiser les URLs vidéo depuis le post
    initializeVideoUrls () {
      const videoUrls = this.getVideoUrlsByNetwork

      // Récupérer l'URL initiale si elle existe
      if (videoUrls.initial) {
        this.formPostAnnonce.linkToVideo = videoUrls.initial
      }

      // Initialiser les URLs par réseau
      this.networks.forEach(network => {
        const networkKey = network.name.toLowerCase()
        if (videoUrls.hasOwnProperty(networkKey)) {
          // Il y a une personnalisation explicite (même si elle est vide)
          this.$set(this.networkVideoUrls, network.name, videoUrls[networkKey])
        } else if (videoUrls.initial) {
          // Si pas d'URL spécifique pour ce réseau, utiliser l'URL initiale
          this.$set(this.networkVideoUrls, network.name, videoUrls.initial)
        }
      })
    },

    // Méthode initializePostData simplifiée utilisant le système centralisé
    initializePostData (post) {
      if (post && post.id === this.currentPostId) {
        this.formPostAnnonce.titre = post.titre

        // Initialiser les photos
        if (post.photos && post.photos.length > 0) {
          this.rawPhotos = post.photos
          this.rawPhotos.forEach((photo, index) => {
            const id = photo.chaine_source || `photo-${index}`
            this.photoSelections.set(id, false)
          })
        }

        // Initialiser l'URL vidéo si elle existe - syntaxe compatible
        if (post.donnees && post.donnees.url_clap && post.donnees.url_clap.valeur !== '') {
          this.formPostAnnonce.linkToVideo = post.donnees.url_clap.valeur
          this.localVideoUrl = post.donnees.url_clap.valeur // Synchroniser avec la variable locale
        }

        this.initializeVideoUrls()
        this.saveOriginalCaptions()

        // Le mediaType sera automatiquement défini par le getter centralisé
        // après l'analyse des médias
      }
    },
    updateNetworkVideoUrl ({ network, url }) {
      // Mettre à jour localement seulement, pas de sauvegarde automatique
      this.$set(this.networkVideoUrls, network, url)

      // Mettre à jour dans le store localement
      this.$store.commit('postManager/updatePostVideoFileUrlCustom', {
        network,
        url
      })
    },
    onChildPhotoSelectionChanged ({ network, photoId, selected, photo }) {
      // Quand un enfant change la sélection d'une photo,
      // on met à jour le parent et tous les autres enfants
      this.photoSelections.set(photoId, selected)

      // Mettre à jour la liste des photos sélectionnées
      if (selected) {
        // Ajouter la photo si elle n'est pas déjà sélectionnée
        if (!this.selectedPhotos.find(p => p.id === photoId)) {
          const photoToAdd = photo || this.adaptedPhotos.find(p => p.id === photoId)
          if (photoToAdd) {
            this.selectedPhotos.push(photoToAdd)
          }
        }
      } else {
        // Retirer la photo de la sélection
        this.selectedPhotos = this.selectedPhotos.filter(p => p.id !== photoId)
      }

      // Force la réactivité pour s'assurer que tous les composants enfants se mettent à jour
      this.$forceUpdate()
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },
    // Nouvelle méthode pour gérer le clic sur "Enregistrer les modifications"
    handleSaveCaption (command) {
      this.currentCommand = command
      // console.log(command)
      if (this.hasBothPhotosAndVideo) {
        this.pendingAction = 'saveCaption'
        this.showMediaWarning = true
      } else {
        this.saveCaption(command)
      }
    },
    // Nouvelle méthode pour gérer le clic sur le bouton de planification
    handleOpenScheduleModal () {
      // Vérifier d'abord si des réseaux sont sélectionnés
      if (this.activeNetworks.length === 0 && !this.hasExistingPlanifications) {
        this.$message({
          type: 'info',
          message: $t('socialMedia.noNetworkSelected')
        })
        return
      }

      // Vérifier la combinaison photos/vidéo
      if (this.hasBothPhotosAndVideo) {
        this.pendingAction = 'openScheduleModal'
        this.showMediaWarning = true
      } else {
        this.openScheduleModal()
      }
    },
    activateNetworksWithExistingPlanifications () {
      const socialStatusPosts = this.getSocialStatusPosts

      this.networks.forEach(network => {
        const networkStatus = socialStatusPosts[network.name]

        // Activer automatiquement les réseaux qui ont déjà des planifications
        if (networkStatus && (networkStatus.status === 'published' || networkStatus.status === 'scheduled')) {
          network.active = true
        }
      })
    },
    // Méthode appelée quand l'utilisateur annule dans la modale d'avertissement
    cancelMediaWarning () {
      this.showMediaWarning = false
      this.pendingAction = null
    },
    // Méthode appelée quand l'utilisateur confirme dans la modale d'avertissement
    confirmMediaWarning () {
      this.showMediaWarning = false

      if (this.pendingAction === 'saveCaption') {
        this.saveCaption(this.currentCommand)
      } else if (this.pendingAction === 'openScheduleModal') {
        this.openScheduleModal()
      }

      this.pendingAction = null
    },
    async saveCaption (command) {
      // console.log(command)
      // Protection contre les appels multiples
      if (this.isSaving) {
        return
      }
      this.isSaving = true

      try {
        let hasErrors = false
        const captionsToSave = []

        // Parcourir tous les réseaux sociaux pour identifier les captions modifiées
        this.networks.forEach(network => {
          const diffuseur = getDiffuseur(network.name, this.universe, this.isBienVendu)
          const currentCaption = this.getCaptionByNetwork(diffuseur, this.$route.params.id)

          if (currentCaption) {
            const originalText = this.originalCaptions.get(diffuseur) || ''
            const currentText = currentCaption.text || ''

            // Vérifier si la caption a changé
            if (originalText !== currentText) {
              // Validation spécifique pour Instagram
              if (network.name === 'Instagram' && currentText.length > 2200) {
                this.$message({
                  type: 'info',
                  message: $t('posts.networks.instagram.popupNumberCharacters')
                })
                hasErrors = true
                return
              }

              captionsToSave.push({
                caption: currentCaption,
                networkName: network.name
              })
            }
          }
        })

        // Construire l'objet post_video_file_url_custom avec les URLs vidéo
        const videoUrls = {
          initial: this.formPostAnnonce.linkToVideo || '',
          facebook: this.networkVideoUrls.Facebook || '',
          instagram: this.networkVideoUrls.Instagram || '',
          google: this.networkVideoUrls.Google || '',
          linkedin: this.networkVideoUrls.Linkedin || ''
        }

        // Filtrer les URLs vides pour ne garder que celles qui ont une valeur
        const filteredVideoUrls = Object.fromEntries(
          Object.entries(videoUrls).filter(([key, value]) =>
            value !== '' && value !== null && value !== undefined
          )
        )

        // Videos
        if (this.getStatusMediaPost.hasVideoUpload) {
          await HTTP_HYPER_ESPACE_BACKEND.put(`/annonce/${this.getCurrentPost.id}/video`)
            .then(response => {
            }).catch(error => {
              console.log(error)
            })
        }

        // Créer une copie du post current avec les URLs vidéo mises à jour
        const updatedPost = {
          ...this.getCurrentPost,
          post_video_file_url_custom: Object.keys(filteredVideoUrls).length > 0 ? filteredVideoUrls : null
        }

        let hasVideoUrlChanges = false
        // Si aucune caption n'a changé, vérifier s'il faut quand même sauvegarder les URLs vidéo
        if (captionsToSave.length === 0 && !hasErrors) {
          // Vérifier si les URLs vidéo ont changé
          const currentVideoUrls = this.getCurrentPost.post_video_file_url_custom || {}
          // console.log(currentVideoUrls)
          hasVideoUrlChanges = (JSON.stringify(currentVideoUrls) !== JSON.stringify(filteredVideoUrls)) || (Object.keys(currentVideoUrls).length === 0)
          // console.log(hasVideoUrlChanges)

          if (!hasVideoUrlChanges) {
            this.$message({
              type: 'info',
              message: $t('socialMedia.noCaption')
            })
            if (command === 'saveAndLeave') {
              this.$router.push({
                name: 'social-posts',
                params: { activeName: 'Annonces' }
              })
            } else {
              return
            }
          }
        }

        // Si il y a des erreurs, ne pas sauvegarder
        if (hasErrors) {
          return
        }

        // Sauvegarder toutes les captions modifiées en utilisant l'action du store avec le post mis à jour
        const savePromises = captionsToSave.map(({ caption }) => {
          return this.$store.dispatch('caption/updateCaption', {
            caption: caption,
            login: this.getSitimmoUser.login,
            post: updatedPost, // Utiliser le post mis à jour avec les URLs vidéo
            emission: this.getCurrentPost.emission,
            isNeedSocialNetwork: this.isNeedSocialNetwork
          })
        })

        // Si des captions doivent être sauvegardées, attendre que toutes les sauvegardes soient terminées
        if (savePromises.length > 0) {
          await Promise.all(savePromises)
        }

        // Si seulement les URLs vidéo ont changé (pas de captions modifiées), effectuer une sauvegarde dédiée
        if (captionsToSave.length === 0) {
          // Utiliser le premier réseau disponible pour la sauvegarde des URLs vidéo uniquement
          const firstNetwork = this.networks[0]
          const diffuseur = getDiffuseur(firstNetwork.name, this.universe, this.isBienVendu)
          const caption = this.getCaptionByNetwork(diffuseur, this.$route.params.id)

          if (caption) {
            await this.$store.dispatch('caption/updateCaption', {
              caption: caption,
              login: this.getSitimmoUser.login,
              post: updatedPost,
              emission: this.getCurrentPost.emission,
              isNeedSocialNetwork: this.isNeedSocialNetwork
            })
          }
        }

        // Mettre à jour les captions originales après sauvegarde réussie
        this.saveOriginalCaptions()

        // Recharger le post depuis le serveur pour avoir les données à jour
        // Ceci est crucial pour que le composant UploadVideo détecte correctement
        // si une vidéo est maintenant dans le post (et non plus temporaire)
        try {
          await this.$store.dispatch('postManager/loadPost', this.$route.params.id)
          // Déclencher une nouvelle analyse des médias pour mettre à jour les statuts
          await this.$store.dispatch('postManager/analyzePostMedias', this.$route.params.id)
        } catch (error) {
          console.warn('Erreur lors du rechargement du post après sauvegarde:', error)
          // Ne pas bloquer le flux principal si le rechargement échoue
        }

        if (command === 'saveAndLeave') {
          this.$router.push({
            name: 'social-posts',
            params: { activeName: 'Annonces' }
          })
        }

        // Message de succès approprié
        let successMessage = ''
        if (captionsToSave.length > 0 && Object.keys(filteredVideoUrls).length > 0) {
          successMessage = `${captionsToSave.length} ${$t('socialMedia.saveSucessCaption')} et URLs vidéo mises à jour`
        } else if (captionsToSave.length > 0) {
          successMessage = `${captionsToSave.length} ${$t('socialMedia.saveSucessCaption')}`
        } else if (Object.keys(filteredVideoUrls).length > 0) {
          successMessage = 'URLs vidéo mises à jour avec succès'
        } else if ((Object.keys(filteredVideoUrls).length === 0) && hasVideoUrlChanges) {
          successMessage = 'URLs vidéo mises à jour avec succès'
        }

        if (successMessage) {
          this.$message({
            type: 'success',
            message: successMessage
          })
        }
      } catch (error) {
        // console.error($t('socialMedia.errorCaptionSaving'), error)
        this.$message({
          type: 'error',
          message: $t('socialMedia.errorCaptionSaving')
        })
        throw error // Re-throw pour que l'appelant puisse gérer l'erreur
      } finally {
        // Réactiver la possibilité de sauvegarder
        this.isSaving = false
      }
    },
    saveOriginalCaptions () {
      // Sauvegarder l'état actuel des captions comme référence pour détecter les changements
      this.networks.forEach(network => {
        const diffuseur = getDiffuseur(network.name, this.universe, this.isBienVendu)
        const caption = this.getCaptionByNetwork(diffuseur, this.currentPostId)
        const text = caption ? caption.text || '' : ''
        this.originalCaptions.set(diffuseur, text)
      })
    },
    goToPreviousPage () {
      this.$ga.event('annonce', 'clic', 'annuler_posts', this.getSitimmoUser.id)
      this.$router.go(-1)
    },
    updateNetworkActive (networkId, isActive) {
      const network = this.networks.find(n => n.id === networkId)
      if (network) {
        network.active = isActive
      }
    },
    updateNetworkStatesAfterChanges (schedulingData, deletionsData) {
      // Désactiver les réseaux qui ont été supprimés et qui n'ont pas de nouvelle planification
      if (deletionsData && deletionsData.length > 0) {
        deletionsData.forEach(deletion => {
          // Vérifier si ce réseau n'a pas une nouvelle planification
          const hasNewPlanification = schedulingData.some(schedule => schedule.network === deletion.network)

          if (!hasNewPlanification) {
            // Désactiver le réseau
            const network = this.networks.find(n => n.name === deletion.network)
            if (network) {
              network.active = false
              // console.log('Réseau désactivé après suppression:', deletion.network)
            }
          }
        })
      }
    },
    findNetworkEvent (networkName, diffuseur) {
      // Essayer d'abord via les événements du calendrier
      const calendarEvents = this.$store.getters['calendarSocialPosts/getListEventsByAnnonceByNetwork'](networkName)

      // console.log('Recherche événement pour:', networkName, diffuseur)
      // console.log('Événements du calendrier:', calendarEvents)

      if (calendarEvents && calendarEvents.length > 0) {
        const networkEvent = calendarEvents.find(event => {
          const isMatchingPortail = event.portails && event.portails.some(portail => portail.code === diffuseur)
          const isNotExecuted = !event.scheduled || event.scheduled.lastExecution === null

          // console.log('Vérification événement:', event.id, 'portails:', event.portails, 'match:', isMatchingPortail, 'notExecuted:', isNotExecuted)

          return isMatchingPortail && isNotExecuted
        })

        if (networkEvent) {
          // console.log('Événement trouvé via calendrier:', networkEvent)
          return networkEvent
        }
      }
      // Si pas trouvé dans le calendrier, essayer de construire à partir des données de postManager
      const socialStatusPosts = this.getSocialStatusPosts
      const networkStatus = socialStatusPosts[networkName]

      // console.log('Status réseau:', networkName, networkStatus)

      if (networkStatus && networkStatus.content && (networkStatus.status === 'scheduled' || networkStatus.status === 'published')) {
        // console.log('Construction événement à partir des données postManager:', networkStatus.content)

        // Si c'est une planification ou une diffusion, on peut utiliser les données existantes
        const eventData = networkStatus.content

        if (eventData.id && eventData.annonces) {
          return eventData
        }
      }

      // console.log('Aucun événement trouvé pour:', networkName)
      return null
    },
    // Méthodes pour la modale de planification
    openScheduleModal () {
      // Si on a des planifications existantes, on peut ouvrir la modale même sans sélection
      if (this.activeNetworks.length === 0 && !this.hasExistingPlanifications) {
        this.$message({
          type: 'info',
          message: 'Veuillez d\'abord sélectionner au moins un réseau social en cochant sa case.'
        })
        return
      }
      this.showScheduleModal = true
    },
    closeScheduleModal () {
      this.showScheduleModal = false
    },
    handleDeactivateNetworks (networksToDeactivate) {
      // Désactiver les réseaux spécifiés
      networksToDeactivate.forEach(networkName => {
        const network = this.networks.find(n => n.name === networkName)
        if (network) {
          network.active = false
        }
      })
    },
    async handleConfirmPublish (schedulingData, deletionsData = []) {
      try {
        // Sauvegarder d'abord les captions modifiées si nécessaire
        await this.saveCaption()

        // Traiter d'abord les suppressions si nécessaire (y compris pour les modifications)
        if (deletionsData && deletionsData.length > 0) {
          const deletionPromises = deletionsData.map(async (deletion) => {
            // Trouver l'événement planifié correspondant à ce réseau
            const networkEvent = this.findNetworkEvent(deletion.network, deletion.diffuseur)
            if (networkEvent) {
              // console.log('Suppression de planification pour:', deletion.network, networkEvent)
              return this.$store.dispatch('calendarSocialPosts/deleteScheduled', [networkEvent])
            } else {
              // console.warn('Aucun événement trouvé pour supprimer:', deletion.network)
              return Promise.resolve()
            }
          })

          await Promise.all(deletionPromises)
        }

        // Pour les modifications de planifications existantes, supprimer d'abord l'ancienne
        const modificationPromises = schedulingData.map(async (networkData) => {
          const { network, diffuseur, option } = networkData
          const socialStatusPosts = this.getSocialStatusPosts
          const networkStatus = socialStatusPosts[network]

          // Si c'est une modification d'une planification existante, supprimer l'ancienne
          if (networkStatus && networkStatus.status === 'scheduled' && option !== 'remove') {
            const oldNetworkEvent = this.findNetworkEvent(network, diffuseur)
            if (oldNetworkEvent) {
              // console.log('Suppression de l\'ancienne planification pour modification:', network, oldNetworkEvent)
              return this.$store.dispatch('calendarSocialPosts/deleteScheduled', [oldNetworkEvent])
            }
          }
          return Promise.resolve()
        })

        await Promise.all(modificationPromises)

        // Mapping des noms de réseaux vers les noms de captions
        const networksCaptions = {
          Facebook: { nameCaption: 'facebook_caption', color: '#3b5998', icon: 'mdi-facebook' },
          Instagram: { nameCaption: 'instagram_caption', color: '#C32AA3', icon: 'mdi-instagram' },
          Google: { nameCaption: 'google_localpost_summary', color: '#4582E9', icon: 'mdi-google-my-business' },
          Linkedin: { nameCaption: 'linkedin_commentary', color: '#0077B5', icon: 'mdi-linkedin' }
        }

        // Collecter les réseaux sans caption pour information
        const networksWithoutCaption = []

        // Puis traiter chaque réseau sélectionné pour publication/planification
        const publishPromises = schedulingData.map(async (networkData) => {
          const { network, diffuseur, option, date } = networkData

          try {
            // Obtenir la caption pour ce réseau
            const caption = this.getCaptionByNetwork(diffuseur, this.currentPostId)

            // Vérifier si la caption existe et a du contenu
            let contentCaption = ''
            if (!caption || !caption.text || caption.text.trim() === '') {
              // Ajouter à la liste des réseaux sans caption
              networksWithoutCaption.push(network)
              // Utiliser une caption vide mais continuer le processus
              contentCaption = ''
            } else {
              contentCaption = caption.text
            }

            // Préparer le cronExpression selon le type de publication
            let cronExpression
            let finalDate
            if (option === 'now') {
              cronExpression = '* * * * *' // Publication immédiate
              finalDate = new Date()
            } else {
              // Publication planifiée
              const newDate = new Date(date)
              cronExpression = generateCronExpression(newDate)
              finalDate = newDate
            }

            // Préparer le payload pour l'API
            const payloadPlanif = {
              annonceurId: this.getCurrentPost.advertiser.id,
              annonceurLogin: this.getCurrentPost.advertiser.login,
              annonces: [parseInt(this.currentPostId)],
              type: 'MANUEL',
              scheduled: {
                cronExpression: cronExpression,
                status: '1'
              },
              cancelBy: null,
              portails: [{ code: diffuseur, value: networkData.valueNetwork || network }]
            }

            // Préparer les données pour l'affichage de l'événement
            const networkInfo = networksCaptions[network]
            const nameCaption = networkInfo.nameCaption

            const newEventPart = {
              titre: this.getCurrentPost.titre,
              name: this.getCurrentPost.titre,
              reference: this.getCurrentPost.reference,
              picture: (this.getCurrentPost.photoPrincipale) ? this.getCurrentPost.photoPrincipale.url : null,
              start: transformDateTypeEnglishWithSpace(finalDate),
              color: networkInfo.color,
              icon: networkInfo.icon,
              [`${nameCaption}`]: contentCaption
            }

            // Dispatcher l'action createEventNow
            const result = await this.$store.dispatch('calendarSocialPosts/createEventNow', {
              payloadPlanif: payloadPlanif,
              newEvent: newEventPart
            })

            // console.log(`Publication créée avec succès pour ${network}`)
            return { success: true, network, result }
          } catch (error) {
            // console.error(`Erreur lors de la publication de ${network}:`, error)
            this.$message.error($t('socialMedia.messageCustomError', {
              option: option === 'now' ? 'publication' : 'planification',
              network: network,
              error: error.message || error
            }))
            return { success: false, network, error }
          }
        })

        // Attendre que toutes les publications soient traitées
        const results = await Promise.all(publishPromises)

        // Vérifier les résultats
        const successCount = results.filter(r => r.success).length
        // const errorCount = results.filter(r => !r.success).length

        // if (errorCount > 0) {
        // console.warn(`${errorCount} publication(s) en erreur sur ${results.length}`)
        // }

        // Mettre à jour l'état des réseaux (désactiver ceux qui sont supprimés)
        this.updateNetworkStatesAfterChanges(schedulingData, deletionsData)

        // Recharger les données des diffusions pour mettre à jour l'affichage
        await this.$store.dispatch('postManager/loadDiffusionAnnonce', {
          postId: this.currentPostId,
          isBienVendu: this.isBienVendu,
          isNotEDITO: false
        })

        // Recharger les événements du calendrier
        await this.$store.dispatch('calendarSocialPosts/loadEvents')
        await this.$store.dispatch('calendarSocialPosts/loadEventsByAnnonce', this.currentPostId)

        // Message de succès approprié
        let message = ''
        if (successCount > 0 && deletionsData.length > 0) {
          message = `${successCount} ${$t('socialMedia.messageSuccessPublishWithDeletions')} ${deletionsData.length} ${$t('socialMedia.messageSuccessDelete')}`
        } else if (successCount > 0 && deletionsData.length === 0) {
          message = `${successCount} ${$t('socialMedia.messageSuccessPublish')}`
        } else if (deletionsData.length > 0) {
          message = `${deletionsData.length} ${$t('socialMedia.messageSuccessDelete')}`
        }

        if (message) {
          this.$message.success(message)
        }

        // Si toutes les publications ont échoué et qu'il n'y a pas de suppressions
        if (successCount === 0 && schedulingData.length > 0 && deletionsData.length === 0) {
          this.$message.error($t('socialMedia.messageError'))
        }
      } catch (error) {
        // console.error($t('socialMedia.messageErrorPublish'), error)
        this.$message.error($t('socialMedia.messageErrorPublish') + (error.message || $t('socialMedia.messageErrorPublishUnknown')))
      }
    }
  },
  mounted () {
    // Réinitialiser les données locales au montage
    this.resetLocalData()

    // Initialiser localVideoUrl avec la valeur actuelle (comme dans PostEditoCreatePublicationInitiale)
    this.localVideoUrl = this.formPostAnnonce.linkToVideo

    // Vérifier que l'ID existe avant de faire les appels
    const postId = this.currentPostId

    if (!postId) {
      console.error('Aucun ID de post trouvé dans les paramètres de route')
      this.$message({
        type: 'error',
        message: 'Erreur : Aucun ID de post fourni'
      })
      this.$router.push({ name: 'posts' })
      return
    }

    // Déclencher le chargement du post puis analyser les médias UNE SEULE FOIS
    this.$store.dispatch('postManager/loadPost', postId).then((post) => {
      this.initializePostData(post)
      // Analyser les médias UNE SEULE FOIS au montage avec délai pour éviter les conflits
      setTimeout(() => {
        this.$store.dispatch('postManager/analyzePostMedias', postId)
      }, 100)
    })
    // console.log('PostManager mounted')
    this.$store.dispatch('caption/loadCaptions', {
      universe: this.universe,
      annonceId: postId,
      bienVendu: this.isBienVendu
    })
      .then(() => {
        // Sauvegarder les captions originales après leur chargement
        this.$nextTick(() => {
          this.saveOriginalCaptions()
        })
      })
    this.$store.dispatch('postManager/loadDiffusionAnnonce', {
      postId: postId,
      isBienVendu: this.isBienVendu,
      isNotEDITO: false
    })

    // Charger les événements du calendrier pour pouvoir gérer les suppressions
    this.$store.dispatch('calendarSocialPosts/loadEvents').then(() => {
      this.$store.dispatch('calendarSocialPosts/loadEventsByAnnonce', postId)
    })

    // Garde fou pour cleaner le repertoire de vidéos temporaires en cas de reste
    HTTP_HYPER_ESPACE_BACKEND.delete('/videos/cleanup')
      .then((response) => {
        // console.log(response)
      })

  },
  destroyed () {
    // console.log('PostManager destroyed')
    this.resetLocalData()
    this.$store.commit('caption/cleanCaptions')
    this.$store.commit('postManager/cleanSocialPosts')
    this.$store.commit('postManager/setCurrentPost', null)
  }
}
</script>

<style lang="scss" scoped>
/* Grille Element UI (même principe que SocialPostEditorialCreate) : largeur utile cohérente avec la zone élargie */
.PostManager-row {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 1rem 0;

  @media (min-width: 992px) {
    padding: 1.5rem 0;
  }
}

.PostManager-col {
  box-sizing: border-box;
  min-width: 0;
}

/* Reprend le décalage des panels RS de la création éditoriale (cf. BlockEditoCreateSocialNetwork) */
.PostManager-networkPanel {
  margin-left: 15px;
}

@media (max-width: 991px) {
  .PostManager-col--networks {
    margin-top: 1rem;
  }

  .PostManager-networkPanel {
    margin-left: 0;
  }
}

.title {
  color: #1a4a56;
  font-weight: 600;
  font-size: 15px;
  margin-top: 15px;
}

.footer-actions-buttons {
  display: flex;
  justify-content: flex-end;
}

.help {
  font-size: 12px;
  color: #6c757d;
  display: block;
  margin-top: 5px;
}

.radio-group-media-type {
  display: flex;
  flex-direction: column;
}

</style>
